export default "__VITE_ASSET__5826e5e8__"